<template>
    <div v-if="!isOfficeLogin">
        <template v-if="variant === 'desktop'">
            <div class="sidebar-desktop__info">
                <div :class="{ 'inactive-base': isOfficeLogin }" @click="changeUser" class="sidebar-desktop__avatar">
                    <img class="choose-student-by-avatar" :src="userImage" />
                </div>
                <div :class="{ 'inactive-base': isOfficeLogin }" @click="changeUser" v-if="hasFirstName" class="sidebar-desktop__name choose-student-by-name">
                  {{ userData.firstName }}
                  <span v-if="hasAgentRole && isAdditionalAccessProfile">(kod dostępu)</span>
                </div>
            </div>
            <div :class="{ 'inactive-base': isOfficeLogin }" @click="changeUser" class="sidebar-desktop__children-select">
                <span class="choose-student-by-label">{{selectUserLabel}}</span>
            </div>
        </template>
        <template v-else-if="variant === 'mobile'">
            <div class="sidebar-mobile__info">
                <div :class="{ 'inactive-base': isOfficeLogin }" @click="changeUser" class="sidebar-mobile__avatar choose-student-by-avatar">
                    <img :src="userImage" />
                </div>
                <div :class="{ 'inactive-base': isOfficeLogin }" @click="changeUser" v-if="hasFirstName" class="sidebar-mobile__name choose-student-by-name">
                  {{ userData.firstName }}
                  <span v-if="isAdditionalAccessProfile">(kod dostępu)</span>
                </div>
            </div>
            <span :class="{ 'inactive-base': isOfficeLogin }" @click="changeUser" class="sidebar-mobile__select-student choose-student-by-label">{{selectUserLabel}}</span>
            <div class="sidebar-mobile__arrow">
                <img
                  @click="closeSidebar"
                  class="arrow"
                  src="@/assets/images/icons/close_gray.svg"
                />
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import avatarGirl from '@/assets/images/avatar/avatar_girl.png';
import avatarBoy from '@/assets/images/avatar/avatar_boy.png';
import avatarMan from '@/assets/images/avatar/avatar_agent_man.jpg';
import avatarWoman from '@/assets/images/avatar/avatar_agent_woman.jpg';

export default {
  data() {
    return {
      userData: null,
    };
  },
  props: {
    variant: {
      type: String,
      required: false,
      default: 'desktop',
    },
  },
  computed: {
    ...mapGetters('students', ['getStudent']),
    ...mapGetters('auth', ['isOfficeLogin', 'isParentProfile', 'isAgentProfile', 'hasAgentRole', 'isAdditionalAccessProfile', 'getAgentData', 'getAdditionalAccessData']),
    hasFirstName() {
      return !!this.userData?.firstName;
    },
    userImage() {
      const firstName = this.userData?.firstName;
      const userId = this.userData?.id;

      if (firstName) {
        const firstNameToLowerCase = firstName.toLowerCase();
        const nameExceptions = [
          'kuba',
          'zawisza',
          'jarema',
          'barnaba',
          'bonawentura',
          'kosma',
          'rokita',
          'lasota',
          'żegota',
          'jan maria',
          'nikita',
          'makita',
          'illia',
        ];
        const idExceptions = [126619];
        const nameValid = ['noemi', 'miriam', 'beatrycze', 'sophie', 'nikol'];
        const isLastLetterA = firstName.slice(-1) === 'a';

        const maleAvatar = this.isAgentProfile || this.isAdditionalAccessProfile ? avatarMan : avatarBoy;
        const femaleAvatar = this.isAgentProfile || this.isAdditionalAccessProfile ? avatarWoman : avatarGirl;

        return (isLastLetterA && !nameExceptions.includes(firstNameToLowerCase)) || nameValid.includes(firstNameToLowerCase) || idExceptions.includes(userId) ? femaleAvatar : maleAvatar;
      }
      return avatarMan;
    },
    selectUserLabel() {
      if (this.isAgentProfile || this.isAdditionalAccessProfile) return this.$t('dashboard.choose_profile');
      return this.$t('dashboard.choose_student');
    },
  },
  created() {
    if (this.isParentProfile) {
      this.userData = this.getStudent;
    } else if (this.isAgentProfile) {
      this.userData = this.getAgentData;
    } else if (this.isAdditionalAccessProfile) {
      this.userData = this.getAdditionalAccessData;
    }
  },
  methods: {
    changeUser() {
      this.$emit('change-user');
    },
    closeSidebar() {
      this.$emit('close-sidebar');
    },
  },
};
</script>
